<div class="location-selection-container">
    <div class="dialog-title-section">
        <h2 class="dialog-title">{{ 'permit.create.location.title' | translate }}</h2>
        <p class="dialog-subtitle">{{ 'permit.create.location.subtitle' | translate }}</p>
    </div>

    <div class="selected-type-container" *ngIf="selectedCategory">
        <div class="selected-type-display">
            <i [ngClass]="(selectedCategory.icon || 'icon-folder') + ' category-icon'"></i>
            <div class="type-content">
                <h3 class="category-title">{{ localizedName(selectedCategory.name) }}</h3>
                <p class="type-title" *ngIf="selectedType">{{ localizedName(selectedType.name) }}</p>
            </div>
        </div>
    </div>

    <!-- The requester's own addresses: a permit applies to a property they are attached to -->
    <div class="addresses-container">
        <div class="addresses-loading" *ngIf="loadingAddresses">
            <app-skeleton-loader height="74px" borderRadius="8px" *ngFor="let i of [1, 2]"></app-skeleton-loader>
        </div>

        <div
            *ngFor="let option of addressOptions"
            class="address-option"
            [class.selected]="isOptionSelected(option)"
            (click)="selectAddressOption(option)"
            role="option"
            [attr.aria-selected]="isOptionSelected(option)"
        >
            <mat-icon class="address-icon">home</mat-icon>
            <div class="address-body">
                <div class="address-heading">
                    <span class="address-name">{{ option.displayName }}</span>
                    <span class="address-badge badge-primary" *ngIf="option.isPrimary">{{ 'permit.create.location.badge_primary' | translate }}</span>
                    <span class="address-badge" [ngClass]="statusBadgeClass(option)" *ngIf="statusBadgeKey(option)">{{ statusBadgeKey(option) | translate }}</span>
                </div>
                <span class="address-line">{{ option.formatted }}</span>
            </div>
        </div>

        <div class="addresses-empty" *ngIf="!loadingAddresses && addressOptions.length === 0">
            {{ 'permit.create.location.no_addresses' | translate }}
        </div>
    </div>

    <div class="divider-text">
        <span>{{ 'permit.create.location.or_another_address' | translate }}</span>
    </div>

    <div class="location-search-container">
        <div class="search-input-wrapper">
            <i class="icon-search search-icon"></i>
            <input
                type="text"
                class="search-input"
                [formControl]="searchControl"
                [placeholder]="'permit.create.location.search_placeholder' | translate"
                [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayAddressFn" (optionSelected)="onAddressSelected($event.option.value)">
                <mat-option *ngFor="let address of addressSuggestions | async" [value]="address">
                    {{ formatAddress(address) }}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>

    <!-- Selected address, with a read-only map preview when we have coordinates for it -->
    <div class="selected-address" *ngIf="address">
        <div class="selected-address-body">
            <mat-icon class="pin-icon">location_on</mat-icon>
            <div class="selected-address-text">
                <span class="address-line">{{ address }}</span>
            </div>
            <button type="button" class="clear-address-btn" (click)="clearAddress()">
                <i class="icon-close"></i>
            </button>
        </div>

        <ng-container *ngIf="coordinates">
            <link
                rel="stylesheet"
                href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
                integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
                crossorigin=""
            />
            <div class="map-container">
                <div id="permit-create-map" class="map-canvas"></div>
                <div class="map-error" *ngIf="mapError">
                    <p>{{ 'permit.create.location.map_error' | translate }}</p>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="site-location-container">
        <label class="site-location-label">{{ 'permit.create.location.site_location' | translate }}</label>
        <input
            type="text"
            class="site-location-input"
            [(ngModel)]="siteLocation"
            (ngModelChange)="onSiteLocationChanged()"
            [placeholder]="'permit.create.location.site_location_placeholder' | translate"
        />
    </div>

    <div class="skip-container">
        <a class="skip-link" (click)="skip()">{{ 'permit.create.location.skip' | translate }}</a>
    </div>
</div>
